export default function Terms({ terms, setTerms }) {
	const { eraAllowed, acceptTerms } = terms;
	return (
		<>
			<div className="shadow-lg overflow-hidden mt-8 sm:rounded-md ">
				<div className="px-6 py-5 ">
					<h2 className="border-b-2 mb-4 md:text-2xl font-semibold">
						Other
					</h2>
					<div className="relative flex items-center px-4 border py-4 rounded-sm">
						<div className="flex items-center h-5">
							<input
								onChange={() => {
									setTerms((prev) => ({
										eraAllowed: !prev.eraAllowed,
										acceptTerms: prev.acceptTerms
									}));
								}}
								aria-describedby="bradfordEra-description"
								name="bradfordEra"
								type="checkbox"
								checked={eraAllowed}
								id="bradfordEra"
								className="focus:ring-transparent h-6 w-6 text-emerald-600 border-gray-300 rounded-sm"
							/>
						</div>
						<div className="ml-3">
							<label
								htmlFor="bradfordEra"
								className="font-medium text-gray-700 cursor-pointer"
							>
								Would you be willing to be contacted by the
								Bradford Era for a story (not using your real
								name)?
							</label>
							<span
								id="bradfordEra-description"
								className="text-gray-500"
							>
								<span className="sr-only">
									Agree to the terms and conditions.
								</span>
							</span>
						</div>
					</div>
					<div className="relative flex items-center mt-8 px-4 border py-4 rounded-sm">
						<div className="flex items-center h-5">
							<input
								aria-describedby="terms-description"
								name="terms"
								required
								checked={acceptTerms}
								type="checkbox"
								id="terms"
								onChange={() => {
									setTerms((prev) => ({
										eraAllowed: prev.eraAllowed,
										acceptTerms: !prev.acceptTerms
									}));
								}}
								className="focus:ring-transparent h-6 w-6 text-emerald-600 border-gray-300 rounded-sm"
							/>
						</div>
						<div className="ml-3">
							<label
								htmlFor="terms"
								className="font-medium text-gray-700 cursor-pointer"
							>
								By signing this you agree to the terms and
								conditions, the information that you have
								provided is accurate and true, and also
								authorize the Era&apos;s Less Fortunate Fund to
								verify all information in this application.
							</label>
							<span
								id="terms-description"
								className="text-gray-500"
							>
								<span className="sr-only">
									Agree to the terms and conditions.
								</span>
							</span>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}
